import React from 'react'
// context
import { KPIContext } from 'context/index'
// constants
import { ENTITIES } from 'constants/index'
// view components
import ReviewsList from 'components/Modals/PlanItems/components/ReviewsList'

const KPIReviewsList: React.FC = () => {
  const { entity } = React.useContext(KPIContext) as any

  const {
    kpiCreateScheduledReview,
    kpiDeleteScheduledReview,
    kpiModifyScheduledReview,
    kpiViewCompletedReview,
    kpiViewInProgressReview
  } = entity.currentPermissions

  return (
    <ReviewsList
      canCreate={kpiCreateScheduledReview}
      canDelete={kpiDeleteScheduledReview}
      canModify={kpiModifyScheduledReview}
      canViewCompleted={kpiViewCompletedReview}
      canViewInProgress={kpiViewInProgressReview}
      entity={{ ...entity, entityType: ENTITIES.PLAN_KPI }}
    />
  )
}

export default KPIReviewsList
